import React, {useState} from "react";
import { Link } from "react-router-dom";
import { Container, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';

import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';

const SyncButton = () => {
  const [loading, setLoading] = useState(false);
  const { instance, accounts } = useMsal();

  const syncDocuments = async () => {
    setLoading(true);
    try {
      const token_response = await instance.acquireTokenSilent({...{scopes: ["User.Read"]}, account: accounts[0]});
      const headers =  {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token_response.accessToken,
      };
      const payload = {
        "search_last_days": 1
      };
      const response = await axios.post("https://openai-intake-app.azurewebsites.net/filevine-polling", payload, {
        headers: headers,
      });
     } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

  
  return (
      <Button variant="contained" onClick={syncDocuments} disabled={loading} startIcon={loading && <CircularProgress size={24} />}>
      {loading ? 'Syncing...' : 'Sync Documents'}
      </Button>
  )
}

function NavigationBar() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <Container
      sx={{ width: "20%", bgcolor: "grey.100", paddingTop: 2 }}
      maxWidth={false}
    >
      <List component="nav">
        <ListItemButton component={Link} to="/">
          <ListItemText primary="Overview" />
        </ListItemButton>
        <ListItemButton component={Link} to="/documents">
          <ListItemText primary="Documents" />
        </ListItemButton>
        <ListItem>
          <div className="collapse navbar-collapse justify-content-end">
          { isAuthenticated ? <SignOutButton /> : <SignInButton />}
          </div>
        </ListItem>
      </List>

    </Container>
  );
}

export default NavigationBar;
